<app-table-widget-layout
  [tableName]="'LeadPortal.dashboard.widget.most-sold-models.title' | translate"
  [listIndexMethod]="listIndexMethod"
  [columnsData]="tableColumns">
</app-table-widget-layout>
